import React from 'react';
import PropTypes from 'prop-types';

import { ErrorControl } from './ErrorControl';

class ErrorBoundary extends React.PureComponent {
  static propTypes = {
    logError: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    errorComponent: PropTypes.node.isRequired,
  };

  state = {
    error: false,
  };

  componentDidCatch(error, info) {
    this.setState({ error: true });
    this.props.logError(error, info);
  }

  render() {
    const { children, errorComponent } = this.props;

    return (
      <ErrorControl
        error={this.state.error}
        errorComponent={errorComponent}
      >
        { children }
      </ErrorControl>
    );
  }
}

export { ErrorBoundary };
export default ErrorBoundary;
